<template>
  <!-- 查看合同页面 -->

  <div class="wrap" style="overflow: hidden">

    <yd-navbar title="预约列表" fontsize="16px" style="font-weight: 800;font-family:PingFang SC;color:#000">
      <router-link to="/supplierIndex" slot="left">
        <yd-navbar-back-icon></yd-navbar-back-icon>
      </router-link>
    </yd-navbar>
    <yd-button style="z-index: 999;position:fixed;bottom:70px;" type="primary" size="large" shape="circle" bgcolor="#2f6fff" color="#fff" @click.native="batchOrder">批量预约<small> (已选择:{{selectCount}})</small></yd-button>
    <yd-button style="z-index: 999;position:fixed;bottom:10px;border: #2f6fff 1px solid" type="hollow" size="large" shape="circle"  @click.native="addContract">添加合同</yd-button>
    <yd-preview :buttons="btns" class="nobtn" v-for="(item,index) in contractList[0].arrList" :key="index">
      <yd-preview-header style="margin-top:5px;">
        <div slot="left" style="text-align: left;font-weight:bolder;">合同编号：{{item.contract_no}}</div>
        <div slot="right" style="position: absolute;right: 0px;"><yd-switch v-model="item.selected" size="small" color="#2f6fff" :val="item.contract_no" :callback="orderSelect" true-value="1"
            false-value="0"></yd-switch>
        </div>
      </yd-preview-header>
<!--      <yd-preview-item>-->
<!--        <div slot="left">合同名称</div>-->
<!--        <div slot="right">{{item.contract_name}}</div>-->
<!--      </yd-preview-item>-->
      <yd-preview-item>
        <div slot="left">供应商编码</div>
        <div slot="right">{{item.supplier_no}}</div>
      </yd-preview-item>
      <yd-preview-item>
        <div slot="left">供应商名称</div>
        <div slot="right">{{item.supplier_name}}</div>
      </yd-preview-item>
      <yd-preview-item>
        <div slot="left">报审序号</div>
        <div slot="right">{{item.contract_no_area}}</div>
      </yd-preview-item>
      <yd-preview-item>
        <div slot="left">签订时间</div>
        <div slot="right">{{item.signDate}}</div>
      </yd-preview-item>
    </yd-preview>
    <yd-preview style="padding: 20px;font-size: 14px;" :buttons="btns" class="nobtn" v-if="contractList[0].arrList.length==0">{{list&&list.content?list.content:'暂无可预约合同'}}</yd-preview>

  </div>
</template>

<script>
import axios from "axios";
var baseUrl = process.env.API_ROOT;
export default {
    data() {
        return {
            tab2:0,
            switch1:true,
            orderCount:this.$route.query.period.leftCount||0,
            selectCount:0,
            contractIds:[],
            btns:[],
            userId:window.localStorage.getItem("checkUserId"),
            period : this.$route.query.period,
            contractSataus: 0,
            contractList: [
                {label: '可预约',status:3, content: '暂无可预约合同',arrList:[]},
                {label: '待核销', status:5,content: '暂无已预约资源',arrList:[]},
                {label: '待用印', status:5,content: '暂无已预约资源',arrList:[]},
                {label: '已取消', status:5,content: '暂无已预约资源',arrList:[]},
                {label: '已退回', status:5,content: '暂无已退回资源',arrList:[]},
                {label: '已用印',status:8, content: '暂无已用印资源',arrList:[]}
            ],
            supplierUser:{
              supplier_no:'',
              supplier_name:'',
              user_name:'',
              status:''
            },
        }
    },
    methods: {
      //不同状态下的合同信息查询方法
      itemClick(key) {
        this.$dialog.loading.open('数据加载中');
        this.tab2 = key;
        this.$dialog.loading.close();
      },
      getInfo(id, status) {
        if (status === "3" || status === 3) {
          this.$router.push({path: "/supplierOrder", query: {contractId: id, period: this.period}});
        }
      },

      //加载可预约合同资源
      getTodoList(userId) {
        axios({
          method: "get",
          url: baseUrl + "todo?userId=" + userId
        }).then(resp => {
          if (resp.data.error_code == "0") {
            this.contractList[0].arrList = resp.data.data
          }
        })
      },
      //加载已经预约合同资源
      getOrderedList(userId) {
        axios({
          method: "get",
          url: baseUrl + "ordered?userId=" + userId
        }).then(resp => {
          if (resp.data.error_code == "0") {
            this.contractList[1].arrList = resp.data.data
          }
        })
      },
      //加载可预约合同资源
      getSignedList(userId) {
        axios({
          method: "get",
          url: baseUrl + "signed?userId=" + userId
        }).then(resp => {
          if (resp.data.error_code == "0") {
            this.contractList[2].arrList = resp.data.data
          }
        })
      },
      orderSelect(obj, value) {
        this.selectCount = 0
        this.contractList[0].arrList.forEach((item, key) => {
          if (item.selected === '1') {
            this.selectCount = this.selectCount + 1;
            if (this.selectCount > this.orderCount) {
              // this.$set(this.contractList[0].arrList[key],'selected','0')
              // item.selected = '0'
              this.$dialog.alert({mes: '不能超过最大可预约数量！'});
            }
          }
        })
      },
      addContract() {
        this.$dialog.confirm({
          title: '提示',
          mes: '仅需添加当天新办理的合同，按照合同签约审查审批表信息录入！',
          opts: [
            {
              txt: '取消',
              color: false,
              callback: () => {
              }
            },
            {
              txt: '确定',
              color: true,
              callback: () => {
                this.$router.push({path: "/supplierAdd", query: {supplierUser: this.supplierUser}});
              }
            }
          ]
        });
      },
      batchOrder() {
        if (this.selectCount === 0) {
          this.$dialog.alert({mes: '请选择要预约的记录！'});
          return
        } else if (this.selectCount > this.orderCount) {
          this.$dialog.alert({mes: '选择的数量不能大于可预约数量！'});
          return
        } else {
          this.contractList[0].arrList.forEach((item) => {
            if (item.selected === '1') {
              this.contractIds.push(item.id)
            }
          })
          axios({
            method: "post",
            url: baseUrl + "batchApply",
            params: {
              userId: this.userId,
              contractIds: this.contractIds.join(","),
              orderId: this.period.orderId || '',
              orderListId: this.period.id || ''
            }
          }).then(resp => {
            if (resp.data.result && resp.data.result === "true") {


              this.$dialog.toast({
                mes: resp.data.msg,
                timeout: 3500,
                icon: 'success'
              });

              this.$router.push({path: "/supplierIndex"});
            } else {
              this.$dialog.toast({mes: resp.data.message, timeout: 1500});
            }
          })
        }
      },
      getSupplierInfo(){
        let userId = window.localStorage.getItem("checkUserId")
        axios({
          method: "get",
          url: baseUrl + "suppplierUserInfo?userId=" + userId
        }).then(resp => {
          if (resp.data.error_code == "0") {
            this.supplierUser = resp.data.data
          } else {
            this.$dialog.toast({ mes: "获取供应商信息失败", timeout: 1500 });
            return;
          }
        });
      },
   },
  mounted() {
     if(!this.userId){
        this.$router.push({ path: "/login"});
     }
     this.getTodoList(this.userId);
     this.getSupplierInfo();
  }
}
</script>

<style scoped>
.yd-preview-header > :last-child {
  font-size: 0.28rem;
  margin-right: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/supplier-contract.vue